/**
 * Auto generated build file to add global access to
 * provided methods
 */

import NotificationsController from "./controllers/notifications-controller";

Stimulus.register("notifications", NotificationsController);
